import { createModel, RematchDispatch } from '@rematch/core';
import * as tourService from '../../services/tour.service';
import { PaginationType } from '../../types/CommonTypes';
import { TourData } from '../../types/TourData';
import { RootModel } from '../models';

import baseEntity from './base.entity';

export const storeName = 'tourEntity';

export const tourEntity: any = createModel<RootModel>()({
  name: storeName,
  state: { ids: {} },
  reducers: {
    ...baseEntity,
  },
  effects: (dispatch: RematchDispatch<typeof tourEntity>) => ({
    async loadById(id, state): Promise<TourData> {
      try {
        const res = await tourService.getTour(id);
        const tour = res.data;
        if (tour) {
          this.saves([tour]);
        }
        return tour;
      } catch (e) {
        throw new Error(e);
      }
    },
    async load(params): Promise<{ content?: TourData[] } & PaginationType> {
      try {
        const res = await tourService.getTours({ params });
        const { content } = res.data;
        if (content && content.length) {
          this.saves(content);
        }
        return res.data;
      } catch (e) {
        throw new Error(e);
      }
    },
    async save(payload) {
      try {
        if (!payload.id) {
          await tourService.createTour(payload);
        } else {
          await tourService.updateTour(payload.id, payload);
        }
      } catch (e) {
        throw new Error(e);
      }
    },
    async delete(id) {
      try {
        const res = await tourService.deleteTour(id);
        if (res && res.data) {
          this.remove({ id });
        }
        return res;
      } catch (e) {
        throw new Error(e);
      }
    },
    async make(payload) {
      try {
        await tourService.makeTour(payload);
      } catch (e) {
        throw new Error(e);
      }
    },
    async clone(id) {
      try {
        await tourService.cloneTour(id);
      } catch (e) {
        throw new Error(e);
      }
    },
    async publish(payload) {
      try {
        const { data: item } = await tourService.publishTour(payload);
        this.update(item);
        return item;
      } catch (e) {
        throw new Error(e);
      }
    },
    async visualize(code, state): Promise<TourData> {
      try {
        const res = await tourService.getTourByCode(code);
        const tour = res.data;
        if (tour) {
          this.saves([tour]);
        }
        return tour;
      } catch (e) {
        throw new Error(e);
      }
    },
    async mergeTour(payload, state): Promise<TourData> {
      try {
        const res = await tourService.mergeTour(payload);
        const tour = res.data;
        if (tour) {
          this.saves([tour]);
        }
        return tour;
      } catch (e) {
        throw new Error(e);
      }
    }
  }),
});

export default tourEntity;
